<template>
  <div class="game" v-if="gameData">
    <!--顶部下载-->
    <headdownload></headdownload>
    <!--顶部游戏大图-->
    <header-cover :cover-url="gameData.game.coverImage"></header-cover>
    <!--  游戏简介-->
    <div class="area describe">
      <describe :icon-url="gameData.game.versionInfo.icon"
                :title="gameData.game.name"
                :type="gameData.publisher.name"
                :brief="gameData.game.versionInfo.fileSize | fileSize"
                :score="getDetailScore(gameData.game.scoreCount,gameData.game.score,gameData.game.interveneScore)"
      ></describe>
    </div>
    <!--    一句话推荐-->
    <div class="area">
      <div class="recommend">
        <div class="recommend-sign"></div>
        <div class="recommend-txt">{{ gameData.game.devRecommend }}</div>
      </div>
    </div>
    <!--    模块-->
    <div class="area">
      <div class="plate" @click="openOfficial">
        <div class="plate-item pitch"><span>详情</span></div>
        <div class="plate-item"><span>评价</span></div>
      </div>
      <!--  功能图标-->
      <function v-if="functionData" :function-data="functionData"></function>
    </div>
    <!--  文章标题-->
    <div class="area area-title" v-if="false">
      <article-title></article-title>
    </div>

    <!--    温馨提示-->
    <div class="area">
      <div class="warmPrompt">
        <div class="warmPrompt-title">{{ gameData.game.messageTitle }}</div>
        <div class="warmPrompt-txt">{{ gameData.game.description }}</div>
        <div class="warmPrompt-skip" @click="openOfficial">点我进入>></div>
      </div>
    </div>
    <!--  游戏截图-->
    <div class="area area-deficiency" v-if="gameData.pictures.length>1">
      <exhibition :exhibition-list="gameData.pictures" :type-list="gameData.tags"></exhibition>
    </div>
    <!--当前版本-->
    <div class="area">
      <div class="thisVersions">
        <div class="thisVersions-title">
          <div class="thisVersions-title-txt">当前版本</div>
          <div class="thisVersions-title-message">
            <div class="thisVersions-title-message-number">v{{ gameData.game.versionInfo.versionName }}</div>
            <div @click="openOfficial" class="thisVersions-title-message-date">{{ gameData.game.versionInfo.releaseTime | dateTimeStr }}</div>
            <div @click="openOfficial"><i data-v-fb7d3d66="" aria-hidden="true" class="fa fa-chevron-right"></i></div>
          </div>
        </div>
        <div class="thisVersions-center">
          <div class="thisVersions-center-item" v-for="(item,index) in thisVersionsList" :key="index">
            <!--            <span class="icon">◆</span>-->
            <span class="txt">{{ item }}</span>
          </div>
        </div>
        <div class="thisVersions-operation">
          <span class="operation" @click="openOfficial">
            收起
            <i data-v-601ecf38="" aria-hidden="true" class="fa fa-chevron-up"></i>
            <!--            <i data-v-601ecf38="" aria-hidden="true" class="fa fa-chevron-down"></i>-->
          </span>
        </div>
      </div>
    </div>
    <!--游戏描述-->
    <div class="area" v-if="gameData.game.editorRecommend!==''">
      <introduce :editor-recommend="gameData.game.editorRecommend" :version-info="gameData.game.versionInfo" title="游戏介绍" pack-txt="展开"></introduce>
    </div>
    <!--    详细信息-->
    <div class="area">
      <div class="detailedInformation">
        <div class="detailedInformation-title">详细信息</div>
        <div class="detailedInformation-center">
          <div class="detailedInformation-center-item" >
            <div class="item-title">当前版本</div>
            <div class="item-txt">{{ gameData.game.versionInfo.versionName }}</div>
          </div>
          <div class="detailedInformation-center-item" >
            <div class="item-title">更新日期</div>
            <div class="item-txt">{{ gameData.game.versionInfo.updateTime | dateTimeStr }}</div>
          </div>
          <div class="detailedInformation-center-item" >
            <div class="item-title">语言</div>
            <div class="item-txt">{{ gameData.game.versionInfo.lang }}</div>
          </div>
          <div class="detailedInformation-center-item" >
            <div class="item-title">系统要求</div>
            <div class="item-txt">{{ gameData.game.versionInfo.adapterInfo }}</div>
          </div>
          <div class="detailedInformation-center-item" >
            <div class="item-title">开发商</div>
            <div class="item-txt link" @click="openOfficial">{{ gameData.publisher.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <!--  猜你喜欢-->
    <div class="area" v-if="likeData.length>1">
      <div class="like">
        <div class="like-title">猜你喜欢</div>
        <div class="like-center">
          <div class="like-center-items" :style="{width:85*4+'px'}">
            <div class="like-center-item" v-for="(item,index) in likeData" :key="index" @click="openOfficial">
              <img :src="item.game.versionInfo.icon">
              <div>{{ item.game.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--底部下载-->
    <floordownload></floordownload>
  </div>
</template>

<script>
import Headdownload from './template/headdownload'
import HeaderCover from './template/headerCover'
import Describe from './template/describe'
import ArticleTitle from './template/articleTitle'
import Function from './template/function'
import Exhibition from './template/exhibition'
import Introduce from './template/introduce'
import overallData from '../../public/js/overall'
import axios from 'axios'
import Floordownload from './template/floordownload'

export default {
  name: 'Game',
  components: { Floordownload, Introduce, Exhibition, Function, ArticleTitle, Describe, HeaderCover, Headdownload },
  data () {
    return {
      axiosUrl: overallData.axiosUrl, // 测试环境
      gameData: null,
      thisVersionsList: [],
      functionData: [],
      likeData: [],
      // 游戏id
      id: ''
    }
  },
  filters: {
    // 文件大小单位转化
    fileSize: function (val) {
      var size = parseInt(val)
      if (size > 0 && size < 1024) {
        return size
      }
      if (size >= 1024 && size < 1024 * 1024) {
        return (size / 1024).toFixed(1) + 'k'
      }
      if (size >= 1024 * 1024 && size < 1024 * 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(1) + 'M'
      }
      if (size >= 1024 * 1024 * 1024 && size < 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + 'G'
      }
      console.log(val)
    },
    // 日期字符串格式
    dateTimeStr: function (val) {
      if (val === '' || val == null) {
        return ''
      }
      const dateTime = new Date(val)
      const dateStr = {
        year: dateTime.getUTCFullYear(),
        month: dateTime.getMonth() + 1 >= 10 ? dateTime.getMonth() + 1 : '0' + (dateTime.getMonth() + 1),
        day: dateTime.getDate() >= 10 ? dateTime.getDate() : '0' + dateTime.getDate(),
        hour: dateTime.getHours() >= 10 ? dateTime.getHours() : '0' + dateTime.getHours(),
        minute: dateTime.getMinutes() >= 10 ? dateTime.getMinutes() : '0' + dateTime.getMinutes(),
        second: dateTime.getSeconds() >= 10 ? dateTime.getSeconds() : '0' + dateTime.getSeconds()
      }
      return dateStr.year + '-' + dateStr.month + '-' + dateStr.day
      // return dateStr.year + '-' + dateStr.month + '-' + dateStr.day + ' ' + dateStr.hour + ':' + dateStr.minute + ':' + dateStr.second
    }
  },
  created () {
    const urlDataJson = {}
    if (window.location.hash.indexOf('?') !== -1) {
      const urlData = window.location.hash.split('?')[1].split('&')
      for (const urlDatum of urlData) {
        urlDataJson[urlDatum.split('=')[0]] = urlDatum.split('=')[1]
      }
      console.log('urlDataJson', urlDataJson)
    }
    this.getListByGpmId(urlDataJson.gameId)
    this.getGameByPublisherAndGameId(urlDataJson.gameId)
    this.getGameInfo(urlDataJson.gameId)
    this.id = urlDataJson.gameId
  },
  methods: {
    openOfficial () {
      window.location.href = 'sbapp:///game_detail?id=' + this.id
      window.location.href = 'https://m.ccspeed.cn/'
    },
    // 游戏详情
    getGameInfo (gameId) {
      const _this = this
      axios.get(this.axiosUrl + '/game/info/getGameInfo', {
        params: {
          gameId: gameId // ID
        }
      })
        .then(function (response) {
          if (response.code === 100000) {
            _this.gameData = response.data
            _this.thisVersionsList = response.data.game.versionInfo.updateLog.split('\r\n')
            console.log(_this.thisVersionsList)
          }
          console.log(response)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 猜你喜欢
    getGameByPublisherAndGameId (gameId) {
      const _this = this
      axios.get(this.axiosUrl + '/game/info/getGameByPublisherAndGameId', {
        params: {
          gameId: gameId // ID
        }
      })
        .then(function (response) {
          if (response.code === 100000) {
            _this.likeData = response.data.list
          }
          console.log(response)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 游戏评分
    getDetailScore (scoreCount, score, interveneScore) {
      if (scoreCount < 3) {
        return '暂无'
      }
      if (score > interveneScore) {
        return score.toFixed(1)
      }
      return interveneScore.toFixed(1)
    },
    // 功能图标
    getListByGpmId (gameId) {
      const _this = this
      axios.get(this.axiosUrl + '/game/helper/getListByGpmId', {
        params: {
          gameId: gameId // ID
        }
      })
        .then(function (response) {
          if (response.code === 100000) {
            _this.functionData = response.data
          }
          console.log(response)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.like{
  .like-title{
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #F5F5F5;
    line-height: 21px;
    margin-bottom: 16px;
  }
  .like-center{
    overflow: auto;
    overflow-y: hidden;
    .like-center-items{
      display: flex;
      flex-wrap: wrap;
      .like-center-item{
        margin-right: 20px;
        width: 63px;
        >img{
          width: 63px;
          height: 63px;
          border-radius: 10px;
        }
        >div{
          font-size: 13px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #EAEAEA;
          line-height: 18px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
  }
}

.detailedInformation{
  .detailedInformation-title{
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #F5F5F5;
    line-height: 21px;
    margin-bottom: 14px;
  }
  .detailedInformation-center{
    background: #202632;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 10px ;
    padding-top: 20px;
    .detailedInformation-center-item{
      width: 40%;
      margin-bottom: 20px;
      .item-title{
        font-size: 11px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #F5F5F5;
        line-height: 14px;
        margin-bottom: 8px;
      }
      .item-txt{
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #68829E;
        line-height: 14px;
      }
      .link{
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #2887EB;
      }
    }
  }
}

.thisVersions{
  .thisVersions-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 13px;
    .thisVersions-title-txt{
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #F5F5F5;
    }
    .thisVersions-title-message{
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #68829E;
      display: flex;
      .thisVersions-title-message-number{
        margin-right: 20px;
      }
      .thisVersions-title-message-date{
        margin-right: 6px;
      }
    }
  }
  .thisVersions-center{
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #68829E;
    .thisVersions-center-item{
      display: flex;
      justify-content: flex-start;
      .icon{
        //transform: rotate(45deg);
        //-ms-transform: rotate(45deg); /* IE 9 */
        //-webkit-transform: rotate(45deg); /* Safari and Chrome */
        font-size: 30px;
        line-height: 21px;
      }
      .txt{
        line-height: 21px;
        margin-left: 5px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
    }
  }
  .thisVersions-operation{
    display: flex;
    justify-content: center;
    margin-top: 18px;
    .operation{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 63px;
      height: 22px;
      background: #202632;
      border-radius: 11px;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #2992FF;
      .fa{
        margin-left: 2px;
      }
    }
  }
}

.warmPrompt{
  background: #202632;
  padding: 8px;
  border-radius: 8px;
  .warmPrompt-title{
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #68829E;
    line-height: 21px;
    margin-bottom: 14px;
  }
  .warmPrompt-txt{
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4C5C6D;
    line-height: 22px;
  }
  .warmPrompt-skip{
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #2992FF;
    line-height: 22px;
    margin-top: 5px;
  }
}
.plate{
  height: 37px;
  background: #202632;
  border: 1px solid #364557;
  border-radius: 8px;
  display: flex;
  .plate-item{
    width: 50%;
    border-radius: 8px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #68829E;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .pitch{
    background: #0D1016;
    border: 1px solid #364557;
    >span{
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #F5F5F5;

      background: linear-gradient(0deg, #2992FF 0%, #00F2C2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}

.recommend{
  display: flex;
  justify-content: flex-start;
  .recommend-sign{
    width: 2px;
    height: 12px;
    background: linear-gradient(0deg, #2992FF, #00F2C2);
    border-radius: 10px;
    margin-top: 3px;
  }
  .recommend-txt{
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4C5C6D;
    margin-left: 5px;
  }
}

.area{
  padding: 0 13px;
  margin-bottom: 30px;
}
.area-deficiency{
  padding-right: 0;
  margin-bottom: 25px;
}
.area-title{
  background-color: #272D3B;
  margin-bottom: 0px;
}
.describe{
  margin-bottom: 0px;
}
</style>
